export const errorsCode = {
  'GENERAL-0001': 'errors.internalServerError',
  'GENERAL-0002': 'errors.badRequest',
  'GENERAL-0003': 'errors.notImplemented',
  'GENERAL-0004': 'errors.resourceNotFound',
  'GENERAL-0005': 'errors.unauthorizedAccess',
  'GENERAL-0006': 'errors.forbiddenAccess',
  'GENERAL-0007': 'errors.domainValidation',
  'GENERAL-0008': 'errors.invalidBodyRequest',
  'AUTH-0001': 'errors.invalidCredentials',
  'USER-0001': 'errors.userNotFound',
  'USER-0002': 'errors.userAlreadyExists',
  'TENANT-0001': 'errors.tenantNotFound',
  'TENANT-0002': 'errors.tenantAlreadyExists',
  'TENANT-0003': 'errors.tenantIsInactive',
  'AWS-COGNITO-0001': 'errors.invalidCredentials',
  'AWS-COGNITO-0002': 'errors.userNotFound',
  'AWS-COGNITO-0003': 'errors.userAlreadyExists',
  'AWS-COGNITO-0004': 'errors.awsCognitoCodeMismatch',
  'AWS-COGNITO-0005': 'errors.awsCognitoExpiredCode',
  'AWS-COGNITO-0006': 'errors.awsCognitoInvalidParameter',
  'AWS-COGNITO-0007': 'errors.awsCognitoInvalidPassword',
  'AWS-COGNITO-0008': 'errors.awsCognitoUserNotConfirmed',
  'AWS-COGNITO-0009': 'errors.awsCognitoLimitExceeded',
  'LEAD-0001': 'errors.leadNotFound',
  'LEAD-0002': 'errors.leadAlreadyExists',
  'MEMBERSHIP-0001': 'errors.membershipNotFound',
  'USER-0003': 'errors.userInactive',
  'USER-0004': 'errors.userNotCreated',
  'USER-0005': 'errors.cannotResetAdminPassword',
  'BILLING-0001': 'errors.subscriptionNotFound',
  'BILLING-0002': 'errors.planNotFound',
  'BILLING-0003': 'errors.quotaExceeded',
  'BILLING-0009': 'errors.subscriptionNoCancelScheduled',
  'BILLING-0010': 'errors.subscriptionNoBillingCycle',
  'BILLING-0012': 'errors.tenantDocumentRequired',
  'TEAM-0001': 'errors.cannotRemoveOwner',
  'TEAM-0002': 'errors.cannotRemoveSelf',
  'TEAM-0003': 'errors.cannotChangeOwnerRole',
  'TEAM-0004': 'errors.ownershipTargetMustBeAdministrator',
  'TEAM-0005': 'errors.cannotChangeSelfRole',
  'INVITATION-0001': 'errors.invitationNotFound',
  'INVITATION-0002': 'errors.invitationExpired',
  'INVITATION-0003': 'errors.invitationCanceled',
  'INVITATION-0004': 'errors.invitationEmailMismatch',
  'INVITATION-0005': 'errors.invitationAlreadyAccepted',
  'INVITATION-0006': 'errors.userAlreadyMember',
  'CONTRACT-0001': 'errors.contractTemplateNotFound',
  'CONTRACT-0002': 'errors.contractTemplateInvalidFile',
  'CONTRACT-0003': 'errors.contractAnalysisFailed',
  'CONTRACT-0004': 'errors.contractNotFound',
  'CONTRACT-0005': 'errors.contractMissingVariables',
  'CONTRACT-0006': 'errors.contractRenderFailed',
  'CONTRACT-0007': 'errors.contractInvalidStatusTransition',
  'CONTRACT-0008': 'errors.contractSignedFileTooLarge',
  'CONTRACT-0009': 'errors.contractTemplateNotTagged',
  'CONTRACTOR-0001': 'errors.contractorNotFound',
  'LEADLEGAL-0001': 'errors.leadLegalInfoNotFound',
  'PORTAL-0001': 'errors.clientPortalAccessDenied',
  'PORTAL-0002': 'errors.clientPortalDocumentRequired',
  global: 'errors.global',
} as const;
